import React from "react";
import { Col, Modal } from "react-bootstrap";
import info from "../../../../images/info.svg";

const Help = (props) => {
  return (
    <>
      <Modal
        show={props.showModalInfo}
        onHide={() => props.setShowModalInfo(false)}
      >
        <Modal.Body className="d-flex flex-wrap justify-content-center align-items-center text-justify">
          <Col>
            <Col className="d-flex flex-wrap justify-content-center align-items-center text-justify ">
              <img src={info} alt="Info" />
            </Col>
            <Col className="d-flex flex-wrap justify-content-center align-items-center text-justify">
              <Modal.Title>Información</Modal.Title>
            </Col>
            <br />
            {/* <Col
              className="shadow-sm rounded p-3"
              style={{ border: "1px solid #ced4da" }}
            >
              <span>
                1. Los cambios tienen la función de autoguardado, al hacer un
                cambio en los campos del cuestionario estos se guardaran
                automaticamente.
              </span>
            </Col> */}
            <Col
              className="shadow-sm rounded p-3"
              style={{ border: "1px solid #ced4da" }}
            >
              <span>
                1. Para guardar los cambios deberá dar clic en el botón con el
                icono de casete, o también desde la opción guardar en el menú
                desplegable.
              </span>
            </Col>
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Help;
